import { FormContext } from "@/lib/Components/Form/Providers/FormContext";
import { useStore } from "zustand";
import { useContext } from "react";

export function useFormEditState() {
  const store = useContext(FormContext);

  if (!store) {
    throw new Error("Missing FormationProvider");
  }
  return useStore(store);
}
